import { render, staticRenderFns } from "./new-landing-page.vue?vue&type=template&id=26ce8bc5&"
import script from "./new-landing-page.vue?vue&type=script&lang=js&"
export * from "./new-landing-page.vue?vue&type=script&lang=js&"
import style0 from "./new-landing-page.vue?vue&type=style&index=0&id=26ce8bc5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports